import { render } from "./NftTable.vue?vue&type=template&id=6e2409c0"
import script from "./NftTable.vue?vue&type=script&lang=js"
export * from "./NftTable.vue?vue&type=script&lang=js"

import "./NftTable.vue?vue&type=style&index=0&id=6e2409c0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__